import { useState } from "react";

const useVisibility = (initialVisibility = {}) => {
    const [visibility, setVisibility] = useState(initialVisibility);

    const show     = (name) => setVisibility(prev => ({ ...prev, [name]: true }));
    const hide     = (name) => setVisibility(prev => ({ ...prev, [name]: false }));
    const toggle   = (name) => setVisibility(prev => ({ ...prev, [name]: !prev[name] }));
    const isVisible = (name) => !!visibility[name];

    return { show, hide, toggle, isVisible };
};

export default useVisibility;
